import {
  getRunApi,
  listRunsApi,
  runExplosionApi,
  ExplosionsApiClientError,
} from './apiClient'
import type {
  ExplosionRun,
  ExplosionRunDetail,
  RunExplosionInput,
} from './types'

export const explosionService = {
  list(): Promise<ExplosionRun[]> {
    return listRunsApi()
  },
  getById(id: string): Promise<ExplosionRunDetail | null> {
    return getRunApi(id)
  },
  run(input: RunExplosionInput): Promise<ExplosionRunDetail> {
    return runExplosionApi(input)
  },
}

export type {
  BomVersionUsed,
  ExplosionAdHocLine,
  ExplosionLineStatus,
  ExplosionRun,
  ExplosionRunDetail,
  ExplosionRunResult,
  ExplosionSourceKind,
  RunExplosionInput,
} from './types'
export { EXPLOSION_STATUS_LABEL } from './types'
export { ExplosionsApiClientError }
